import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry/service-providers')({
  component: undefined,
  context: () => ({
    getBreadcrumbData: () => ({
      id: null,
      translationKey: 'breadcrumbs.serviceProviders',
    }),
  }),
  beforeLoad: ({ location }) => {
    if (location.pathname === '/registry/service-providers') {
      throw redirect({
        to: '/dashboard/service-providers',
      });
    }
  },
});
